<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import GameReferee from "./GameReferee";
import store from "@/store/store";
import { GameRefereeBase } from "vue-chess-shared/GameRefereeBase";
import { firestore } from "@/services/firebase";
import Chess from "chess.js";
import { serverTimestamp } from "@/utils/firebase-helper";

class GameRefereeLocal extends GameRefereeBase {
  engine() {
    return new Chess();
  }

  firestore() {
    return firestore;
  }

  serverTimestamp() {
    return serverTimestamp();
  }

  async fetchData() {
    const { getLocalMatchById: getMatch, getLocalMovesByMatchId: getMoves } =
      store.getters;

    this.match = getMatch(this.matchId);
    this.moves = getMoves(this.matchId);

    await this.loadEngine();
    await this.checkAbortOrTimeout();
    await this.checkMatchUserAction();
    await this.handleMove();
    await this.checkLastMoveUserAction();
  }

  updateMatch(payload) {
    store.dispatch("saveLocalMatch", {
      matchId: this.matchId,
      payload: payload,
    });
  }

  async setSchedule(seconds) {
    this.timerId = setTimeout(() => {
      this.updateMatch({
        updatedAt: new Date(),
      });
    }, seconds * 1000);
  }

  async clearSchedules() {
    if (!this.timerId) {
      return;
    }

    clearTimeout(this.timerId);
  }

  reset() {
    if (!this.timerId) {
      return;
    }

    console.log("referee reset");

    clearTimeout(this.timerId);
  }
}

export default {
  name: "GameRefereeLocal",

  extends: GameReferee,

  computed: {
    ...mapGetters({
      getMoves: "getLocalMovesByMatchId",
      getMatch: "getLocalMatchById",
    }),

    match() {
      return this.getMatch(this.matchId);
    },

    moves() {
      return this.getMoves(this.matchId);
    },
  },

  watch: {
    match: {
      deep: true,
      handler() {
        if (this.match.endedAt) {
          this.referee.reset();
          return;
        }
        this.handleChange();
      },
    },

    moves: {
      deep: true,
      handler() {
        this.handleChange();
      },
    },
  },

  methods: {
    handleChange: _.debounce(function () {
      this.referee.fetchData();
    }, 500),
  },

  beforeCreate() {
    this.referee = new GameRefereeLocal();
  },
};
</script>
